module.exports = __webpack_public_path__ + "Roboto-Regular.woff2?73f0a88bbca1bec19fb1303c689d04c6";


//////////////////
// WEBPACK FOOTER
// ./src/assets/css/fonts/Regular/Roboto-Regular.woff2?v=2.137
// module id = 195
// module chunks = 7